<!-- Template -->

<template>
    <ul class="nav nav-tabs horizontal" role="tablist">
        <li class="nav-item"
            v-for="tab in tabs"
            :key="tab.name">
            <router-link class="nav-link" :class="{ active: active === tab.name }" :to="{ name: 'System', params: { hospital: hospital.id, system: system.id, tab: tab.name } }">
                {{tab.text}}
            </router-link>
        </li>
    </ul>   
</template>

<!-- Script -->

<script>
    export default {
        name: 'SystemNavigation',

        props: [
            'active',
            'tabs',
            'hospital',
            'system'
        ]
    }
</script>

